export enum UsoImovelTipo {
  RESIDENCIAL = 'RESIDENCIAL',
  COMERCIAL = 'COMERCIAL',
  MISTO = 'MISTO',
}
